import type { FC, ReactNode } from 'react';
import clsx from 'clsx';
import React, { useCallback, useRef } from 'react';

const classes = clsx(
  ['px-1'],
  ['border-t', 'border-t-negative'],
  ['border-b', 'border-b-transparent'],
  ['inline'],
  ['text-main-500', 'bg-negative'],
  ['whitespace-pre-wrap', 'break-normal', '-ml-1', '-mr-1'],
  ['selection:bg-main-500', 'selection:text-negative']
);

export type InlineCodeProps = {
  children?: ReactNode;
};

export const InlineCode: FC<InlineCodeProps> = ({ children }) => {
  const ref = useRef<HTMLElement>(null);
  const handler = useCallback(() => {
    if (ref.current) {
      window.getSelection()?.selectAllChildren(ref.current);
    }
  }, []);
  return (
    // eslint-disable-next-line
    <code
      ref={ref}
      data-testid="inline-code"
      className={classes}
      onClick={handler}
    >
      {children}
    </code>
  );
};
